import React from 'react'
import styled from 'styled-components';

export const ErrorMsg = styled.p`
	font-size:.9rem;
	color: #fd8686;
`

